import {
  LetterbookSettingType,
  LetterbookRowComponentType,
} from "features/Letterbooks/types";
import TableHeaders from "./TableHeaders";
import { LetterbooksSerializersLetterbook } from "types/serializers";

interface LetterbooksCollectionOptions {
  letterbooks: LetterbooksSerializersLetterbook[];
  settings: LetterbookSettingType;
  RowComponent: LetterbookRowComponentType;
}

export default function CardCollection({
  letterbooks,
  settings,
  RowComponent,
}: LetterbooksCollectionOptions) {
  return (
    <div className="w-full overflow-scroll">
      <table className="mt-4 table-auto w-full shadow-md border-separate border-spacing-y-2">
        <TableHeaders settings={settings} />

        <tbody className="space-y-2">
          {letterbooks.map((letterbook) => (
            <RowComponent
              settings={settings}
              key={letterbook.position}
              letterbook={letterbook}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
